import { Controller } from "@hotwired/stimulus"
import { drawTrace } from "../modules/trace_draw"

// Progressive enhancement for the Article Trace. Since PR5 the canonical trace is
// server-rendered inline as static SVG (crawlable, no-JS safe), so this controller
// is a NO-OP whenever the <svg> already holds bars — the server trace always wins.
// It only fills an EMPTY <svg> from a data-blocks recipe: editor previews and
// future client-only surfaces that have no server-baked trace.
//
// Controller element: anything carrying data-blocks="prose,code,..." with an <svg>
// child (e.g. a .rr-trace host). A [data-blockcount] child receives the honest
// recipe length.
export default class extends Controller {
  connect() {
    const svg = this.element.querySelector("svg")
    if (!svg) return

    const types = (this.element.dataset.blocks || "")
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean)

    const countEl = this.element.querySelector("[data-blockcount]")
    if (countEl && !countEl.textContent.trim()) countEl.textContent = String(types.length)

    // Canonical server trace present -> leave it. No redraw, no double DOM work.
    if (svg.querySelector("rect")) return
    if (types.length === 0) return

    drawTrace(
      svg,
      types.map((type) => ({ type, w: type === "marker" ? 0.4 : 1 })),
      160,
      22,
      1.8,
      1.2
    )
  }
}
